import axios from 'axios';
const CREDIT_CARD_BE_PREFIX = '/apps/creditcard';

export default {
	getInitData() {
		return axios.get(CREDIT_CARD_BE_PREFIX + '/api/precalc/init');
	},
	preCalculate(data, operatorToken) {
		if (operatorToken) {
			return axios.post(CREDIT_CARD_BE_PREFIX + '/api/precalc/calculate?pnOperatorToken=' + operatorToken, data);
		} else {
			return axios.post(CREDIT_CARD_BE_PREFIX + '/api/precalc/calculate', data);
		}
	},
	startCalculation(data) {
		return axios.post(CREDIT_CARD_BE_PREFIX + '/api/credit-card/claim/start', data);
	},
	sendTa(data) {
		return axios.post(CREDIT_CARD_BE_PREFIX + '/api/credit-card/ta', data);
	}
};
